import React from 'react';
import { Switch } from 'react-router-dom';
import { FourOhFourErrorPage } from '@sm/webassets';

import Layout from '~pricing/components/Layout';
import pages from '~pricing/pages';
import useTreatment from '~pricing/hooks/useTreatment';

import PricingRoutes from './PricingRoutes';

const PricingRouter = (): JSX.Element => {
  const {
    uiExperiment: { ENTERPRISE_FEATURES_GP69 },
  } = useTreatment();

  // GP-69: this experiment is a full page take over for enterprise users
  // viewing the pricing pages and doesn't fit into the standard page layout.
  // we'll let it provide all of its own <BasePage> stuff as necessary

  if (ENTERPRISE_FEATURES_GP69) {
    return <ENTERPRISE_FEATURES_GP69.EnterpriseFeatures />;
  }

  return (
    <Layout>
      <Switch>
        {pages().map(page =>
          page.paths.map((path: string) => (
            <PricingRoutes key={path} path={path} exact redirectPath="/pricing" component={page.component} />
          ))
        )}
        <FourOhFourErrorPage />
      </Switch>
    </Layout>
  );
};

export default PricingRouter;
